var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer text-center no-print"},[_vm._v("\r\n\t"+_vm._s(_vm.date)+" ©\r\n\t"),(_vm.$platform)?_c('span',[_vm._v("\r\n\t\t"+_vm._s(_vm.$platform.name)+"\r\n\t")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56f6ea49","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/partials/views/html/Foot.html
// module id = null
// module chunks = 